export class MediaItem {
    "mediaItemId": string;
    "publicUrl": string; // http://....jpg FILE URL
    "mediaId": string;
    "config": any;
    "showSeconds": number;
    "filename": string; // image.jpg, videofile.mp4, ..
    "companyId": string;
    "sortNr": number;
}